import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCreditInstallments } from "services/akbank";

const initialState = {
  installementList: [],
};

export const fetchInstallementList = createAsyncThunk("creditCalculation/fetchInstallements", async () => {
  try {
    const response = await getCreditInstallments();
    return response;
  } catch (error) {
    console.error("Error fetching installment list:", error);
    throw error;
  }
});

export const creditCalculation = createSlice({
  name: "creditCalculation",
  initialState,
  reducers: {
    setInitialInstallementList: (state, action) => {
      state.favoriteModalOpened = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInstallementList.fulfilled, (state, action) => {
      state.installementList = action.payload;
    });
  },
});

export const { setInitialInstallementList } = creditCalculation.actions;

export default creditCalculation.reducer;
